import { PortBerthingTypes } from '../enums/port-berthing-types.enum';

// A port's berthingType describes what the port supports (its capacity), not the
// operative mode used for a given port call or tariff. BOTH and THIRD are capacity-only
// values that expand into the concrete operative types they cover — they must never be
// sent as a port call's plannedBerthingType or as a tariff's berthingType.
export function relevantBerthingTypesForCapacity(capacity?: string | null): PortBerthingTypes[] {
  switch (capacity) {
    case PortBerthingTypes.BOTH:
      return [PortBerthingTypes.ALONG_SIDE, PortBerthingTypes.MED_MOOR];
    case PortBerthingTypes.THIRD:
      return [PortBerthingTypes.MED_MOOR, PortBerthingTypes.ALONG_SIDE, PortBerthingTypes.ANCHOR];
    case PortBerthingTypes.ALONG_SIDE:
      return [PortBerthingTypes.ALONG_SIDE];
    case PortBerthingTypes.MED_MOOR:
      return [PortBerthingTypes.MED_MOOR];
    case PortBerthingTypes.ANCHOR:
      return [PortBerthingTypes.ANCHOR];
    case PortBerthingTypes.STERN_ONLY:
      return [PortBerthingTypes.STERN_ONLY];
    case PortBerthingTypes.SIDE_POSSIBLE:
      return [PortBerthingTypes.SIDE_POSSIBLE];
    default:
      return [PortBerthingTypes.ALONG_SIDE, PortBerthingTypes.MED_MOOR, PortBerthingTypes.ANCHOR];
  }
}
